export default __webpack_public_path__ + "static/media/LEXUS.a0b494ba.jpg";